import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

// ----------------------------------------------------------------------------

function _AdminRoomCard(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, room, onClick } = props

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`} onClick={onClick}>
            <div className="image">
                <img src={room?.images?.[0]}></img>
            </div>
            <div className="text-box">
                <span className="title">{room?.title}</span>
                <div className="info">
                    <span>{room?.attributes?.numTenants ?? 3} coinquilini</span>
                    <div className="sep"></div>
                    <span>{room?.attributes?.numRooms} camere</span>
                    <div className="sep"></div>
                    <span>{room?.attributes?.numBathrooms} bagni</span>
                    <div className="sep"></div>
                    <span>Lavatrice</span>
                    <div className="sep"></div>
                    <span>Aria condizionata</span>
                </div>
                <div className="rent-wrapper">
                    <span className="rent">{room?.rent}€</span>
                    <span className="per-month"> / mese</span>
                </div>
            </div>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_AdminRoomCard.propTypes = {
    className: PropTypes.string.isRequired,
    room: PropTypes.object,
    onClick: PropTypes.func,
}

_AdminRoomCard.defaultProps = {}

// ----------------------------------------------------------------------------

const AdminRoomCard = styled(_AdminRoomCard)`
    & {
        width: 100%;
        height: 380px;
        background-color: white;
        border-radius: 10px;
        overflow: hidden;
        max-width: 400px;

        display: flex;
        flex-direction: column;

        cursor: pointer;

        .image {
            height: 150px;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .text-box {
            padding: 15px;
            display: flex;
            flex-direction: column;
            flex: 1;

            .title {
                margin-bottom: 10px;
                display: block;
                font-size: 18px;
            }

            .rent-wrapper {
                margin-top: auto;
                font-size: 18px;
                .rent {
                    font-weight: 700;
                }
                .per-month {
                }
            }

            .info {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                color: ${({ theme }) => theme.colors.dark500};
            }
            .sep {
                display: inline-block;
                align-self: center;
                width: 3px;
                height: 3px;
                background-color: ${({ theme }) => theme.colors.dark500};
                border-radius: 100%;
                margin: 0px 5px;
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default AdminRoomCard
